/**
 * Turn hook filter-stage counters into a user-facing reason for hidden rows.
 * Used by classic Suggested Legs so a 158→146 drop is explained, not silent.
 */

const STAGE_LABELS = {
  afterGhost: 'no prices yet',
  afterStale: 'game already started',
  afterUnreliableBooks: 'only on prediction markets / offshore books',
  afterDateKeyword: 'outside the date you asked for',
  afterRelevance: "didn't match your search",
  afterSearchText: 'search box text',
  afterChips: 'your filter chips',
  afterPositiveEv: '+EV only',
  afterMinBooks: 'quality floor (too few traditional books)',
  afterMyBooks: 'not on enough of My Books',
  afterAllFilters: 'Main/Alt filter',
};

export function explainFilterDrop(stageCounts) {
  if (!Array.isArray(stageCounts) || stageCounts.length < 2) return null;
  const parts = [];
  for (let i = 1; i < stageCounts.length; i++) {
    const prev = stageCounts[i - 1];
    const cur = stageCounts[i];
    const drop = (prev.count || 0) - (cur.count || 0);
    if (drop > 0) {
      parts.push({
        stage: cur.name,
        label: STAGE_LABELS[cur.name] || cur.name,
        drop,
        remaining: cur.count,
      });
    }
  }
  const input = stageCounts[0]?.count || 0;
  const output = stageCounts[stageCounts.length - 1]?.count || 0;
  const hidden = input - output;
  if (hidden <= 0) return null;
  return { input, output, hidden, parts };
}

export function formatFilterDropSubtitle(stats, minBooks = 5) {
  if (!stats?.hidden) return null;
  const minPart = stats.parts.find((p) => p.stage === 'afterMinBooks');
  if (minPart && stats.parts.length === 1) {
    return `${stats.hidden} hidden — fewer than ${minBooks} traditional books (quality floor). Not missing data.`;
  }
  if (minPart && minPart.drop === stats.hidden) {
    return `${stats.hidden} hidden — fewer than ${minBooks} traditional books (quality floor). Not missing data.`;
  }
  const bits = stats.parts.map((p) => (p.stage === 'afterMinBooks'
    ? `${p.drop} with fewer than ${minBooks} traditional books`
    : `${p.drop} ${p.label}`));
  return `${stats.hidden} hidden by filters: ${bits.join(', ')}.`;
}
